const swiper = {
	init() {
		new window.Swiper('.swiper', {
			loop: true,
			navigation: {
				nextEl: '.swiper-navigation--next',
				prevEl: '.swiper-navigation--prev',
			},
		})
	},
}

export default swiper
